import React from 'react';

export const LoaderIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0003 1.66797V5.0013M10.0003 15.0013V18.3346M4.10866 4.10964L6.46699 6.46797M13.5337 13.5346L15.892 15.893M1.66699 10.0013H5.00033M15.0003 10.0013H18.3337M4.10866 15.893L6.46699 13.5346M13.5337 6.46797L15.892 4.10964"
      stroke={props?.color || '#027A48'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
